import { initContract } from '@ts-rest/core';
import { z } from 'zod';
const c = initContract();
/** Mirrors the response shape of the backend address controller. */
export const AddressSchema = z.object({
    id: z.string(),
    name: z.string(),
    street: z.string(),
    zipCode: z.string(),
    city: z.string(),
    country: z.string(),
    organizationId: z.string(),
    isPersonal: z.boolean(),
    companyName: z.string().optional(),
    recipientName: z.string().optional(),
    email: z.string().optional(),
    phone: z.string().optional(),
});
export const CreateAddressBodySchema = z.object({
    organizationId: z.string(),
    name: z.string().optional().nullable(),
    street: z.string(),
    zipCode: z.string(),
    city: z.string(),
    country: z.string(),
    isPersonal: z.boolean().default(false),
    companyName: z.string().optional().nullable(),
    recipientName: z.string().optional().nullable(),
    email: z.string().email('Email invalide'),
    phone: z.string().min(1, 'Le numéro de téléphone est requis'),
});
export const UpdateAddressBodySchema = z.object({
    name: z.string().optional(),
    street: z.string(),
    zipCode: z.string(),
    city: z.string(),
    country: z.string(),
    isPersonal: z.boolean().default(false),
    companyName: z.string().optional().nullable(),
    recipientName: z.string().optional().nullable(),
    email: z.string().email('Email invalide'),
    phone: z.string().min(1, 'Le numéro de téléphone est requis'),
});
export const addressContract = c.router({
    listAddresses: {
        method: 'GET',
        path: '/addresses',
        query: z.object({ organizationId: z.string().min(1) }),
        responses: {
            200: z.array(AddressSchema),
        },
        summary: 'List the addresses of an organization',
    },
    createAddress: {
        method: 'POST',
        path: '/addresses',
        body: CreateAddressBodySchema,
        responses: {
            201: z.boolean(),
        },
        summary: 'Create an address',
    },
    updateAddress: {
        method: 'PUT',
        path: '/addresses/:id',
        pathParams: z.object({ id: z.string().min(1) }),
        body: UpdateAddressBodySchema,
        responses: {
            200: z.boolean(),
        },
        summary: 'Update an address',
    },
    deleteAddress: {
        method: 'DELETE',
        path: '/addresses/:id',
        pathParams: z.object({ id: z.string().min(1) }),
        body: c.noBody(),
        responses: {
            200: z.boolean(),
        },
        summary: 'Delete an address',
    },
});
